// extracted by css-extract-rspack-plugin
export default {"modalContainer":"_c1d1ae10","modalClose":"_3c24b881"};